// Footer.jsx
import React from "react";
import PixelIcons from "./PixelIcons.jsx";
import { useT } from "../i18n/useT.js";
import { Link } from "react-router-dom";

const { Heart, Coin, Star } = PixelIcons;

const ftStyles = {
  foot: {
    borderTop: "1px solid var(--border-soft)",
    padding: "48px 0 32px",
    background: "var(--ragross-purple-night)",
    position: "relative",
  },
  container: { maxWidth: 1280, margin: "0 auto", padding: "0 32px" },
  top: { display: "grid", gridTemplateColumns: "1.5fr 1fr 1fr 1fr", gap: 32, marginBottom: 36 },
  brand: { display: "flex", flexDirection: "column", gap: 14, maxWidth: 360 },
  brandRow: { display: "flex", alignItems: "center", gap: 14 },
  logo: { height: 48, filter: "drop-shadow(0 0 12px rgba(253,20,145,0.4))" },
  name: { font: "var(--type-h2)", color: "#fff", margin: 0 },
  tagline: { font: "var(--type-body-sm)", color: "var(--fg-2)", margin: 0 },
  col: { display: "flex", flexDirection: "column", gap: 12 },
  colHead: {
    fontFamily: "'Press Start 2P', monospace",
    fontSize: "9px", letterSpacing: "0.14em",
    color: "var(--ragross-cyan)",
    display: "flex", alignItems: "center", gap: 8,
  },
  link: { font: "var(--type-body-sm)", color: "var(--fg-2)", textDecoration: "none" },
  bottom: {
    paddingTop: 24, borderTop: "1px solid var(--border-soft)",
    display: "flex", justifyContent: "space-between", alignItems: "center",
    flexWrap: "wrap", gap: 12,
  },
  bottomLeft: {
    fontFamily: "'Press Start 2P', monospace",
    fontSize: "9px", letterSpacing: "0.12em",
    color: "var(--fg-3)",
    display: "flex", alignItems: "center", gap: 10,
  },
  bottomRight: { fontFamily: "'VT323', monospace", fontSize: 16, color: "var(--ragross-cyan)" },
};

export default function Footer() {
  const t = useT();
  return (
    <footer style={ftStyles.foot}>
      <div className="pixel-divider" style={{ marginBottom: 48 }}></div>
      <div style={ftStyles.container}>
        <div style={ftStyles.top} className="responsive-grid-4">
          <div style={ftStyles.brand}>
            <div style={ftStyles.brandRow}>
              <img src="/assets/logos/ragross-owl-emblem.png" alt="" style={ftStyles.logo} />
              <div>
                <div style={ftStyles.name}>Ragross Studios</div>
                <div style={{ fontFamily: "'Press Start 2P', monospace", fontSize: "9px", color: "var(--ragross-gold)", letterSpacing: "0.16em", marginTop: 6 }}>
                  {t("ft.tag")}
                </div>
              </div>
            </div>
            <p style={ftStyles.tagline}>{t("ft.tagline")}</p>
          </div>

          <div style={ftStyles.col}>
            <span style={ftStyles.colHead}><Heart size={10} /> {t("ft.colStudio")}</span>
            <Link to="/estudio" style={ftStyles.link}>{t("nav.lvl02")}</Link>
            <Link to="/servicios" style={ftStyles.link}>{t("nav.lvl03")}</Link>
            <Link to="/portafolio" style={ftStyles.link}>{t("nav.lvl04")}</Link>
            <Link to="/talleres" style={ftStyles.link}>{t("nav.lvl06")}</Link>
            <Link to="/tienda" style={ftStyles.link}>{t("nav.lvl07")}</Link>
            <Link to="/blog" style={ftStyles.link}>{t("nav.lvl08")}</Link>
          </div>

          <div style={ftStyles.col}>
            <span style={ftStyles.colHead}><Coin size={10} /> {t("ft.colSocial")}</span>
            <a href="https://www.instagram.com/ragross.studios/" target="_blank" rel="noreferrer" style={ftStyles.link}>Instagram</a>
            <a href="https://www.facebook.com/Ragross.Studios" target="_blank" rel="noreferrer" style={ftStyles.link}>Facebook</a>
            <a href="https://twitter.com/Ragross_Studios" target="_blank" rel="noreferrer" style={ftStyles.link}>Twitter / X</a>
            <a href="https://www.linkedin.com/company/40865187/" target="_blank" rel="noreferrer" style={ftStyles.link}>LinkedIn</a>
          </div>

          <div style={ftStyles.col}>
            <span style={ftStyles.colHead}><Star size={10} /> {t("ft.colContact")}</span>
            <span style={ftStyles.link}>proyectos@ragrosstudios.com</span>
            <a href="https://wa.me/573189717723" target="_blank" rel="noreferrer" style={ftStyles.link}>+57 318 971 7723</a>
            <span style={ftStyles.link}>Cali · Colombia</span>
            <span style={{ ...ftStyles.link, color: "var(--ragross-green)", fontFamily: "'VT323', monospace", fontSize: 17 }}>{"> "}{t("ft.response")}</span>
          </div>
        </div>

        <div style={ftStyles.bottom}>
          <span style={ftStyles.bottomLeft}>
            <span style={{ width: 7, height: 7, background: "var(--ragross-green)", boxShadow: "var(--glow-green-md)" }}></span>
            {t("ft.rights")}
          </span>
          <span style={ftStyles.bottomRight}>
            {"> "} {t("ft.thanks")}<span className="blink">▮</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
